import React from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import { PageUrls } from '@utils/constants/PageUrls';
import { SPARK_YOUTUBE_VIDEO } from '@store/LocationAssetsTrackingData';
import VideoBackgroundImage from '@static/images/figures/spark-video-bg.webp';

import * as styles from './SparkCaseStudy.module.scss';

export const SparkCaseStudy: React.FC = () => {
	return (
		<PaddingContainer className="gray-bg">
			<WidthContainer className={styles.container}>
				<div className="row no-gutters flex-row-reverse">
					<div className="col12 col-md-6">
						<div className={styles.content}>
							<p className="font-size-small-title mb-3 font-600">
								Management in agro-industries
							</p>
							<p className="font-size-sm mb-4">
								Spark Control is an indoor positioning system for large areas.
								UWB solution made it work with a precision ranging from 5-10 cm.
							</p>
							<Link
								to={PageUrls.SPARK_CASE_STUDY}
								className="bttn bttn-orange-border link"
							>
								See full case study
							</Link>
						</div>
					</div>
					<div
						className={classNames(
							styles.videoContainer,
							'col-12 col-md-6 d-flex align-items-center justify-content-center pt-5 pt-md-0'
						)}
					>
						<iframe
							className={styles.video}
							src={SPARK_YOUTUBE_VIDEO}
							frameBorder="0"
							allow="autoplay; encrypted-media"
							allowFullScreen
							title="video"
						/>
						<img className={styles.bgImage} src={VideoBackgroundImage} />
					</div>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
